@if (orderDetails$ | async; as orderDetails) {
  <div class="header">
    <div class="business-name">
      <a [href]="orderDetails.accountLink" target="_blank" rel="noopener noreferrer">
        {{ orderDetails.business?.napData?.companyName || '-' }}
      </a>
    </div>
  </div>
  <div>
    @if (orderDetails.business?.napData; as napData) {
      <span>{{ napData.address }} </span>
      @if (napData.address2) {
        <span>{{ napData.address2 }}</span>
      }
      <span>{{ napData.city }} {{ napData.state }} {{ napData.country }} {{ napData.zip }}</span>
      @if (orderDetails.business?.napData?.workNumber?.[0] && orderDetails.business?.napData?.workNumber?.[0] !== '') {
        <span> | </span>
        <a href="tel:{{ orderDetails.business?.napData?.workNumber[0] }}">
          {{ orderDetails.business?.napData?.workNumber[0] }}
        </a>
      }
    }
  </div>
}
